import { Language, PageView } from '../types';
import { TRANSLATIONS } from '../translations';
import { ArrowLeft } from 'lucide-react';

interface LegalPagesProps {
    pageView: PageView;
    language: Language;
    setPageView: (view: PageView) => void;
}

export default function LegalPages({ pageView, language, setPageView }: LegalPagesProps) {
    const t = TRANSLATIONS[language];

    const renderPrivacy = () => (
        <div className="space-y-4">
            <h1 className="text-2xl font-bold text-[#6b9b7a]">{t.privacy_title}</h1>
            <p className="text-[#e8e4db] opacity-80">{t.privacy_intro}</p>
            <ul className="space-y-3 text-[#e8e4db]">
                <li className="bg-[#1a1a1a] p-4 rounded-lg">
                    <strong className="text-[#6b9b7a]">1.</strong> {t.privacy_point_1}
                </li>
                <li className="bg-[#1a1a1a] p-4 rounded-lg">
                    <strong className="text-[#6b9b7a]">2.</strong> {t.privacy_point_2}
                </li>
                <li className="bg-[#1a1a1a] p-4 rounded-lg">
                    <strong className="text-[#6b9b7a]">3.</strong> {t.privacy_point_3}
                </li>
            </ul>
        </div>
    );

    const renderAbout = () => (
        <div className="space-y-4">
            <h1 className="text-2xl font-bold text-[#6b9b7a]">{t.about_title}</h1>
            <p className="text-[#e8e4db] opacity-80 leading-relaxed">{t.about_text}</p>

            <div className="bg-[#1a1a1a] p-4 rounded-lg mt-6">
                <h2 className="font-semibold text-white mb-2">{t.about_features}</h2>
                <ul className="list-disc list-inside text-[#888] space-y-1">
                    <li>{t.about_feature_1}</li>
                    <li>{t.about_feature_2}</li>
                    <li>{t.about_feature_3}</li>
                    <li>{t.about_feature_4}</li>
                    <li>{t.about_feature_5}</li>
                </ul>
            </div>

            <div className="bg-[#1a1a1a] p-4 rounded-lg">
                <h2 className="font-semibold text-white mb-2">{t.about_credits}</h2>
                <p className="text-[#888] text-sm">
                    {t.about_credits_text}
                </p>
            </div>
        </div>
    );

    const renderContact = () => (
        <div className="space-y-4">
            <h1 className="text-2xl font-bold text-[#6b9b7a]">{t.contact_title}</h1>
            <p className="text-[#e8e4db] opacity-80">{t.contact_text}</p>

            <div className="bg-[#1a1a1a] p-6 rounded-lg text-center">
                <p className="text-lg text-[#e8e4db]">{t.contact_email}</p>
                <a
                    href="mailto:hello@aotdle.com"
                    className="inline-block mt-4 px-6 py-2 bg-[#4a7c59] hover:bg-[#2d5a3c] text-white rounded-lg transition-colors"
                >
                    {t.send_email}
                </a>
            </div>

            <div className="bg-[#1a1a1a] p-4 rounded-lg">
                <h2 className="font-semibold text-white mb-2">{t.follow_us}</h2>
                <p className="text-[#888] text-sm">
                    Twitter: @aotdle
                </p>
            </div>
        </div>
    );

    return (
        <div className="flex-grow">
            <div className="max-w-2xl mx-auto px-4 py-8">
                <button
                    onClick={() => setPageView('game')}
                    className="flex items-center gap-2 text-[#6b9b7a] hover:text-[#8bbb9a] transition-colors mb-6"
                >
                    <ArrowLeft size={20} />
                    {t.back_to_game}
                </button>

                {pageView === 'privacy' && renderPrivacy()}
                {pageView === 'about' && renderAbout()}
                {pageView === 'contact' && renderContact()}
            </div>
        </div>
    );
}
